import { ReactNode } from "react";
import { PrivateRoute } from "../components/PrivateRoute";
import LoginPage from "../pages/LoginPage";
import Landing from "../pages/VirtualChallenge/Landing";
import Challenges from "../pages/Challenges/Challanges";
import ViewMap from "../pages/ViewMap/ViewMap";
import LocationTracker from "../components/LocationTracker";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import SuperAdminDashboard from "../pages/Admin/SuperAdminDashboard";
import ChallengePortal from "../pages/ChallengePortal/ChallengePortal";

export const routes: Array<{ path: string; component: ReactNode }> = [
  // Public
  { path: "/", component: <Landing /> },
  { path: "/portal/:brandId/:productId", component: <ChallengePortal /> },
  { path: "/:brandId/challenge-portal/:productId", component: <ChallengePortal /> },
  { path: "/:brandId/:userId", component: <Challenges /> },
  { path: "/map/:brandId/:productId/:userId", component: <ViewMap /> },
  { path: "/:brandId/:userId/tracker", component: <LocationTracker /> },
  { path: "/tracker", component: <LocationTracker /> },

  // Login page (public)
  { path: "/login", component: <LoginPage /> },

  // Protected
  {
    path: "/admin",
    component: (
      <PrivateRoute>
        <AdminDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: "/superadmin",
    component: (
      <PrivateRoute>
        <SuperAdminDashboard />
      </PrivateRoute>
    ),
  },
];
